// react-redux imports
import { useSelector } from "react-redux";
import { RootState } from "app/store";

import StyledBackground from "./styled-components/StyledBackground";

function Background() {
  const urlSelector = useSelector((state: RootState) => state.background.url);
  const colorSelector = useSelector(
    (state: RootState) => state.background.color
  );
  const headerWidthMode = useSelector(
    (state: RootState) => state.header.widthMode
  );

  return (
    <StyledBackground
      url={urlSelector}
      color={colorSelector}
      headerWidthMode={headerWidthMode}
    />
  );
}

export default Background;
